import { createClient } from '@supabase/supabase-js';

/**
 * Cria um usuário usando uma instância separada do Supabase
 * Isso evita interferir na sessão atual
 */
export const createUserSeparateInstance = async (userData) => {
  try {
    // Criar uma nova instância do Supabase para esta operação
    const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
    const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
    
    if (!supabaseUrl || !supabaseAnonKey) {
      throw new Error('Configuração do Supabase não encontrada');
    }

    // Nova instância isolada
    const isolatedSupabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: false, // Não persistir sessão
        autoRefreshToken: false, // Não renovar token automaticamente
        detectSessionInUrl: false // Não detectar sessão na URL
      }
    });

    console.log('Criando usuário com instância isolada...');

    // Criar usuário na instância isolada
    const { data, error } = await isolatedSupabase.auth.signUp({
      email: userData.email,
      password: userData.password,
      options: {
        emailRedirectTo: undefined,
        data: {
          created_by_admin: true
        }
      }
    });

    if (error) {
      throw error;
    }

    if (!data.user) {
      throw new Error('Falha ao criar usuário');
    }

    console.log('Usuário criado com sucesso na instância isolada:', data.user.id);

    // A instância isolada será descartada automaticamente
    // A sessão principal não é afetada
    
    return {
      success: true,
      user: data.user,
      method: 'isolated_instance'
    };

  } catch (error) {
    console.error('Erro ao criar usuário com instância isolada:', error);
    throw error;
  }
};

export default createUserSeparateInstance;